import HeroSection from "../../components/HeroSection";
import headerImage from "../../assets/heroImages/Prodotti.jpg";

const titolo = <>Prodotti</>;
export default function Prodotti() {
    return (<>
        <HeroSection
        backgroundImg={headerImage}
        title={titolo}
        buttonName="Richiedi una call gratuita"
        buttonLink="/contatti"
        />
    </>
    );
}